import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdateAccrualPolicyRequestSchema,
  TUpdateAccrualPolicyResponseSchema,
} from "./updateAccrualPolicy.schema";

export const updateAccrualPolicy = (axios: IAxiosInstance) => {
  return async ({
    companyID,
    id,
    policy_name,
  }: TUpdateAccrualPolicyRequestSchema) => {
    const { data } = await axios.noRetry.patch<
      IApiResponse<TUpdateAccrualPolicyResponseSchema>
    >(`/accrual-policies/${id}?companyID=${companyID}`, {
      policy_name,
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Something went wrong");
  };
};
